export default {
  google: "Google Maps",
  bing: "Bing Maps",
  apple: "Apple Maps",
  facebook: "Facebook"
};
